export const VIDEO_DETECTION_MODEL = {
	models: [
		{
			id: 'BFM',
			label: 'Reindeer v8 (BFM v2)',
			description: 'BFM v2 reindeer detector (reindeer-bfm-v8) with tracking, on GPU',
			modelVersion: 'base_models/bfm/trained/reindeer-bfm-v8/reindeer-bfm-v8.pt',
		},
		{
			id: 'BFM-SAM3-STREAM',
			label: 'BFM + SAM3 Tracking',
			description: 'Biofind Model with SAM3 streaming segmentation and tracking',
			modelVersion: 'base_models/bfm/checkpoint_best_total.pth',
		},
		{
			id: 'SAM3',
			label: 'SAM3 (Segmentation)',
			description: 'SAM3 segmentation-only model',
			modelVersion: null,
		},
	],
	defaultModelId: 'BFM',
};

/** Pre-built select options for use in form components */
export const MODEL_OPTIONS = VIDEO_DETECTION_MODEL.models.map(model => ({
	value: model.id,
	label: model.label,
	modelVersion: model.modelVersion,
}));

/** Default select option (matches defaultModelId) */
export const DEFAULT_MODEL_OPTION =
	MODEL_OPTIONS.find(m => m.value === VIDEO_DETECTION_MODEL.defaultModelId) || MODEL_OPTIONS[0];

/** O(1) lookup map: model ID → human-readable label */
const MODEL_LABEL_MAP = Object.fromEntries(VIDEO_DETECTION_MODEL.models.map(m => [m.id, m.label]));

/**
 * Get the human-readable label for a model ID.
 * Falls back to the raw ID if not found in config.
 */
export const getModelLabel = modelId =>
	MODEL_LABEL_MAP[modelId] || modelId;
